"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationFieldAngleInputState = exports.LocationFieldInputState = void 0;
var tslib_1 = require("tslib");
var i18n_1 = require("../../i18n");
var number_input_state_1 = require("./number.input.state");
var RE_ANGLE = /^\s*[+-]?((\.\d+)|(\d+(\.\d+)?))°?$/;
var LocationFieldInputState = /** @class */ (function (_super) {
    tslib_1.__extends(LocationFieldInputState, _super);
    function LocationFieldInputState(label, precision, minimumInputPrecision) {
        if (precision === void 0) { precision = 6; }
        if (minimumInputPrecision === void 0) { minimumInputPrecision = 0; }
        var _this = _super.call(this, label, precision, minimumInputPrecision) || this;
        _this.isLabelShown = false;
        _this.isErrorShown = false;
        return _this;
    }
    return LocationFieldInputState;
}(number_input_state_1.NumberInputState));
exports.LocationFieldInputState = LocationFieldInputState;
var LocationFieldAngleInputState = /** @class */ (function (_super) {
    tslib_1.__extends(LocationFieldAngleInputState, _super);
    function LocationFieldAngleInputState(label, precision, minimumInputPrecision, maxValue) {
        if (precision === void 0) { precision = 6; }
        if (minimumInputPrecision === void 0) { minimumInputPrecision = 0; }
        if (maxValue === void 0) { maxValue = 0; }
        var _this = _super.call(this, label, precision, minimumInputPrecision) || this;
        _this.isLabelShown = false;
        _this.isErrorShown = false;
        _this.maxValue = maxValue;
        return _this;
    }
    LocationFieldAngleInputState.prototype.parseInputValue = function (val) {
        if (val.match(RE_ANGLE) == null) {
            this.setError(i18n_1.T.NUMBER_INVALID);
            return NaN;
        }
        //if the input value is a valid angle, we remove the potential '°' character and then manage it as a regular number
        val = val.split('°').join('');
        var res = _super.prototype.parseInputValue.call(this, val);
        if (this.maxValue !== 0 && (Math.abs(res) > this.maxValue)) {
            this.setError((0, i18n_1.Translate)(i18n_1.T.LOCATION_FIELD_OUT_OF_RANGE, { field: (0, i18n_1.Translate)(this.label), maxValue: this.maxValue }));
            return null;
        }
        return res;
    };
    return LocationFieldAngleInputState;
}(LocationFieldInputState));
exports.LocationFieldAngleInputState = LocationFieldAngleInputState;
//# sourceMappingURL=LocationField.input.state.js.map